import React from 'react'

export const SeparatorSettings = () => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
